export default `float i,j,e,g,h,s;
    p.y-=p.z*.5;
    for(j=s=h=.01;j++<9.;s+=s)
      p.xz*=rotate2D(2.),
      h+=abs(sin(p.x*s)*sin(p.z*s))/s;
    return max(0.,p.y+h);
  }`